import { Swiper, Tabs, Toast } from "antd-mobile"
import { SwiperRef } from "antd-mobile/es/components/swiper"
import { memo, useEffect, useRef, useState } from "react"
import Schedule from "./components/schedule";
import ApplyInfo from "./components/applyInfo";
import "./index.scss"
import FileData from "./components/fileData";
import { getQueryParams } from "@src/util";
import { getApplyInfoByIdf } from "@src/service/applyFormSubService";

const tabItems = [
  { key: '1', title: '审批进度' },
  { key: '2', title: '申请信息' },
  { key: '3', title: '文件资料' },
]

const OrderDetail = () => {

  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanid, setLoanId] = useState<string>("");
  const [userInfo,setUserInfo] = useState<any>();

  useEffect(() => {
    document.title = "订单详情"
  }, [])

  useEffect(() => {
    const search = getQueryParams();
    setLoanId(search.loanid);
    getUserInfo(search.no);
  }, [])

  // 获取用户填写信息
  const getUserInfo =async (no:string) => {
    try{
      const data =await getApplyInfoByIdf(no);
      setUserInfo(data);
    }catch(err:any){
      Toast.show(err?.errmsg);
    }
  }



  return (<div className="OrderDetail">
    <Tabs
      activeKey={tabItems[activeIndex].key}
      onChange={key => {
        const index = tabItems.findIndex(item => item.key === key);
        setActiveIndex(index);
        swiperRef.current?.swipeTo(index);
        window.scroll(0, 0)
      }}
      activeLineMode='fixed'
      style={{
        '--title-font-size': '15px',
        '--fixed-active-line-width': '34px'
      }}
    >{
        tabItems.map(_ele => (
          <Tabs.Tab title={_ele.title} key={_ele.key} />
        ))
      }
    </Tabs>

    <Swiper
      style={{ height: "calc(100vh - 46px)" }}
      direction='horizontal'
      loop
      indicator={() => null}
      ref={swiperRef}
      defaultIndex={activeIndex}
      onIndexChange={index => {
        setActiveIndex(index)
      }}
    >
      <Swiper.Item >
        <Schedule loanid={loanid} />
      </Swiper.Item>
      <Swiper.Item>
        <ApplyInfo userInfo={userInfo}/>
      </Swiper.Item>
      <Swiper.Item>
        <FileData userInfo={userInfo?.loanCredential} />
      </Swiper.Item>
    </Swiper>
  </div>)
}

export default memo(OrderDetail);